<section class="no-auth-page">
  <header>
    <h3>Welcome</h3>
    <h4>Complete your profile to start using Hubtype</h4>
  </header>

  <form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
    <div class="ht-form-item">
      <div class="ht-form-item-title">Email</div>
      <div class="ht-form-item-control">
        <ht-input
          label="Email"
          type="email"
          formControlName="email"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    <div class="ht-form-item">
      <div class="ht-form-item-title">Username</div>
      <div class="ht-form-item-control">
        <ht-input
          label="Username"
          type="text"
          formControlName="username"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    <div class="ht-form-item">
      <div class="ht-form-item-title">First name</div>
      <div class="ht-form-item-control">
        <ht-input
          label="First name"
          type="text"
          formControlName="first_name"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    <div class="ht-form-item">
      <div class="ht-form-item-title">Last name</div>
      <div class="ht-form-item-control">
        <ht-input
          label="Last name"
          type="text"
          formControlName="last_name"
          [fullWidth]="true"
        ></ht-input>
      </div>
    </div>

    @if (form.errors?.serverError) {
      <div class="ht-form-row">
        <div class="error-alert">
          <i class="fa-solid fa-circle-xmark"></i>
          <span>{{ form.errors?.serverError }}</span>
        </div>
      </div>
    }

    <div class="ht-form-actions">
      <button
        ht-button-primary
        type="submit"
        size="large"
        [fullWidth]="true"
        [isLoading]="isLoading"
      >
        Continue
      </button>
    </div>
  </form>
</section>
